import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import DashboardOverviewSection from "../components/dashboard/DashboardOverviewSection";
import TodaySessionsSection from "../components/dashboard/TodaySessionsSection";
import AIAnalyticsSection from "../components/dashboard/AIAnalyticsSection";
import PaymentOverviewSection from "../components/dashboard/PaymentOverviewSection";

const Dashboard = () => {
  return (
    <AdminLayout>
      <DashboardOverviewSection />
      <TodaySessionsSection />
      <AIAnalyticsSection />
      <PaymentOverviewSection />
    </AdminLayout>
  );
};

export default Dashboard;
